module.exports = __webpack_public_path__ + "static/fonts/PorscheNextWCy-Bold.7ba1b59.woff";


//////////////////
// WEBPACK FOOTER
// ./static/fonts/PorscheNextWCy-Bold.woff
// module id = H6l0
// module chunks = 5